import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import DeleteConfirm from "../../components/alert/deleteAlert";
import withStyles from "@material-ui/core/styles/withStyles";
import {
  listVehicleTypes,
  getVehicle,
  listVehicles
} from "../../graphql/queries";
import { deleteVehicleType, createVehicleType } from "../../graphql/mutations";
import gql from "graphql-tag";
import { API, graphqlOperation } from "aws-amplify";
import ShowVehicle from "./showVehicle";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import { ToastContainer, toast } from "react-toastify";
import { withApollo } from "react-apollo";
import { flowRight } from "lodash";
import Pagination from "../../components/pagination/pagination";
import {
  Button,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";
import { styles } from "../../assets/css/styles.js";

import AddIcon from "@material-ui/icons/Add";
var schema = require("../../graphql/schema.json");
class Vehicles extends Component {
  state = {
    vehiclesList: [],
    show: false,
    id: "",
    vehicleType: "",
    vehicleCategory: "",
    open: false,
    delete_item: {},
    vehicleCategories: [],
    dropdowOpen: false,
    start: 0,
    end: 10
  };

  deleteVehicle = () => {
    let { vehiclesList, delete_item } = this.state;
    let input = {};
    input.id = delete_item.id;
    API.graphql(graphqlOperation(deleteVehicleType, { input }))
      .then(res => {
        vehiclesList.splice(vehiclesList.indexOf(delete_item), 1);
        this.setState({ vehiclesList, delete_item: {}, open: false });
        this.componentDidMount();
      })
      .catch(err => {
      });
  };
  changeHandler = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };
  submitHandler = e => {
    e.preventDefault();
    let { vehicleCategory, vehicleType, vehiclesList } = this.state;
    let id = Date.now();
    let input = { id, vehicleCategory, vehicleType };
    // if (id === '' || id === null) document.getElementById('id').focus();
    if (vehicleType === "" || vehicleType === null)
      document.getElementById("vehicleType").focus();
    else if (vehicleCategory === "" || vehicleCategory === null)
      document.getElementById("vehicleCategory").focus();
    else {
      API.graphql(graphqlOperation(createVehicleType, { input }))
        .then(res => {
          let item = res.data.createVehicleType;
          vehiclesList.push(item);
          toast.success("Vehicle type added");
          this.setState({ vehiclesList, show: false });
          const { client } = this.props;
          this.props.storeVehicalTypes(client);
        })
        .catch(err => {
        });
    }
  };
  toggleDropdowon = () => {
    this.setState({ dropdowOpen: !this.state.dropdownOpen });
  };
  createVehicle = () => {
    let { show, vehicleType, vehicleCategory, vehicleCategories } = this.state;
    let { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader className={classes.cardHeader}>
              <h4
                style={{ cursor: "pointer" }}
                className={classes.cardTitleWhite}
                onClick={() => this.setState({ show: !show })}
              >
                <AddIcon />
                New Vehicle Type
              </h4>
            </CardHeader>
            {show && (
              <CardBody>
                <Row className="justify-content-left">
                  <Col lg={7}>
                    <Form>
                      <Row>
                        <Col lg={6}>
                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText></InputGroupText>
                              </InputGroupAddon>
                              <Input
                                id="vehicleType"
                                placeholder="Add Vehicle Type"
                                onChange={this.changeHandler}
                                type="text"
                                value={vehicleType}
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText></InputGroupText>
                              </InputGroupAddon>
                              <Input
                                id="vehicleCategory"
                                value={vehicleCategory}
                                onChange={this.changeHandler}
                                placeholder="Type Name"
                                type="select"
                              >
                                {vehicleCategories.map(item => {
                                  return (
                                    <option style={{ color: "black" }}>
                                      {item}
                                    </option>
                                  );
                                })}
                              </Input>
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>

                      <div className="text-center">
                        <Row lg="12" className="px-3 ">
                          <Col>
                            <Button
                              className=" btn-lg  mt-2"
                              color="primary"
                              type="submit"
                              onClick={this.submitHandler}
                            >
                              Submit
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </CardBody>
            )}
          </Card>
        </GridItem>
      </GridContainer>
    );
  };
  onCancel = () => {
    this.setState({ open: false, delete_item: {} });
  };
  openDelete = item => {
    this.setState({ open: true, delete_item: item });
  };
  changePage = i => {
    let start = i * 10 - 10,
      end = i * 10;
    this.setState({ start, end });
  };
  mainDiv = (vehiclesList, props) => {
    let { open, start, end } = props;
    let { classes } = this.props;
    if (vehiclesList.length <= 0) this.createVehicle();
    return (
      <Fragment>
        {this.createVehicle()}
        <DeleteConfirm
          onCancel={this.onCancel}
          onConfrim={this.deleteVehicle}
          open={open}
        />
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader className={classes.cardHeader}>
                <h4 className={classes.cardTitleWhite}>
                  List of Vehicles Types
                </h4>
                <p className={classes.cardCategoryWhite}>Details</p>
              </CardHeader>
              <CardBody style={{ minHeight: 585 }}>
                <ShowVehicle
                  data={vehiclesList.slice(start, end)}
                  onDelete={this.openDelete}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        {vehiclesList.length > 0 && (
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Pagination
                onPageSelect={this.changePage}
                start={start}
                data={vehiclesList}
              />
            </GridItem>
          </GridContainer>
        )}
      </Fragment>
    );
  };
  componentDidMount() {
    let category = schema.data.__schema.types.filter(item => {
      return item.name === "VEHICLECATEGORY";
    });
    this.setState({
      vehicleCategories: category[0].enumValues.map(item => {
        return item.name;
      })
    });
    this.setState({ vehicleCategory: "TRUCK" });
    const { client, user } = this.props;
    this.props.storeVehicalTypes(client);
  }
  render() {
    return (
      <Fragment>
        <ToastContainer />
        {this.mainDiv(this.props.vehicleTypes, this.state)}
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    loading: state.inspections.loading,
    vehicleTypes: state.vehicleTypes.data
  };
};
const mapDispatchToProps = dispatch => {
  return {
    storeVehicalTypes: client => {
      client
        .query({
          query: gql(listVehicleTypes),
          fetchPolicy: `network-only`,
          variables: { limit: 1000 }
        })
        .then(res => {
          let { items } = res.data.listVehicleTypes;
          dispatch({ payload: items, type: "success" });
        })
        .catch(err => {
          dispatch({ payload: [], type: "false" });
        });
      // dispatch({ type:'VehicalTypeSuccess' , data: data });
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(flowRight(withApollo)(withStyles(styles)(Vehicles)));



// WEBPACK FOOTER //
// ./src/admin/vehicle/vehicle.jsx